import axios from 'axios';
import TokenService from "./Token.service";
import Rest from './Rest';
// Base URL of the API  
// const API_BASE_URL = 'https://localhost:7160/api/E_Comm'; 
const API_BASE_URL = process.env.REACT_APP_API_URL;

export class DonorService {
  static async getDonorList(pagination) {
    return Rest.post(`${API_BASE_URL}/donor-listing`, pagination)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error fetching requestor list:', error);
        throw error;
      });
  }

  static async deleteUpcomingDonation(params) {
    return Rest.post(`/cancel-appointment`, params)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error cancelling appointment:', error.response?.data || error.message);
        throw error;
      });
  }
  static async acceptJob(payload) {
    return Rest.post(`${API_BASE_URL}/donor-accept-job`, payload)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error accepting job:', error);
        throw error;
      });
  }
  static async changeAppointmentTime(params) {
    return Rest.post('/change-appointment-time', params)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error Changing appointment time:', error);
        throw error;
      });
  }
  static async getUpcomingDonationList(params) {    
    return Rest.post('/upcoming-donations', params)
    .then(response => {
      return response.data;
    })
    .catch(error => {
      console.error('Error in fetching upcoming donations:', error);
      throw error;
    });
  }
  static async getUpcomingDonationsCount(params) {    
    return Rest.post('/upcoming-donation-count', params)
    .then(response => {
      return response.data;
    })
    .catch(error => {
      console.error('Error in getting upcoming donations count:', error);
      throw error;
    });
  }
  static async getDonationHistoryList(pagination) {
    return Rest.post(`${API_BASE_URL}/donation-history`, pagination)
    .then(response => {
      return response.data;
    })
    .catch(error => {
      console.error('Error Donation History list:', error);
      throw error;
    }); 
    // Dummy data for donation history
    // return {
    //   "success": true,
    //   "message": "Upcoming donation list fetched successfully.",

    //   "data": {
    //     "total": 5,
    //     "limit": 10,
    //     "offset": 0,
    //     "list": [
    //       {
    //         "date": "September 6, 2022",
    //         "time": "10:00 am",
    //         "jobNumber": "SH-00000006",
    //         "location": "Downtown Clinic",
    //         "sample_id": "1",
    //         "compensation": "5",
    //         "status": "completed",
    //         "bloodVolume": "25",
    //         "noOfSticks": 2,
    //         "arrivalDetails": 'on-time',
    //         "donationNote": ""
    //       },
    //       {
    //         "date": "August 31, 2022",
    //         "time": "11:30 am",
    //         "jobNumber": "SH-00000007",
    //         "location": "City Hospital",
    //         "sample_id": "2",
    //         "compensation": "15",
    //         "status": "no-show",
    //         "bloodVolume": "25",
    //         "noOfSticks": 2,
    //         "arrivalDetails": 'on-time',
    //         "donationNote": ""
    //       },
    //       {
    //         "date": "August 31, 2022",
    //         "time": "02:00 pm",
    //         "jobNumber": "SH-00000008",
    //         "location": "Health Center A",
    //         "sample_id": "3",
    //         "compensation": "50",
    //         "status": "completed",
    //         "bloodVolume": "25",
    //         "noOfSticks": 2,
    //         "arrivalDetails": '10 mins',
    //         "donationNote": ""
    //       },
    //       {
    //         "date": "January 11, 2023",
    //         "time": "09:00 am",
    //         "jobNumber": "SH-00000009",
    //         "location": "Eastside Medical",
    //         "sample_id": "4",
    //         "compensation": "7",
    //         "status": "no-show",
    //         "bloodVolume": "25",
    //         "noOfSticks": 2,
    //         "arrivalDetails": 'no-show',
    //         "donationNote": ""
    //       },
    //       {
    //         "date": "December 1, 2022",
    //         "time": "01:00 pm",
    //         "jobNumber": "SH-00000010",
    //         "location": "Westside Clinic",
    //         "sample_id": "1, 2, 3 ,4 ,5, 6, 7, 8",
    //         "compensation": 17,
    //         "status": "completed",
    //         "bloodVolume": 25,
    //         "noOfSticks": 2,
    //         "arrivalDetails": '20 mins',
    //         "donationNote": [
    //           { id: 1, labe: 'Blood', note: "Blood received" },//blood
    //           { id: 2, labe: 'Urine', note: "Urine received" },//Urine
    //           { id: 3, labe: 'Exhaled Breath', note: "Exhaled Breath received" },//Exhaled Breath
    //           { id: 4, labe: 'Saliva', note: "Saliva received" },//Saliva
    //           { id: 5, labe: 'Buccal Swab', note: "Buccal Swab received" },//Buccal Swab
    //           { id: 6, labe: 'Hair Follicle', note: "Hair Follicle received" },//Hair Follicle
    //           { id: 7, labe: 'Skin Tape', note: "Skin Tape received" },//Skin Tape
    //           { id: 8, labe: 'Stool', note: "Stool received" },//Stool
    //         ]
    //       }
    //     ]
    //   }
    // };
  }

  static async getJobsList(pagination) {
    return Rest.post(`${API_BASE_URL}/job-board-list`, pagination)
    .then(response => {
      return response.data;
    })
    .catch(error => {
      console.error('Error fetching job list:', error);
      throw error;
    }); 
  }
  
  static async getJobsDetails(payload) {
    return Rest.post(`${API_BASE_URL}/view-job-board`, payload    )
    .then(response => {
      return response.data;
    })
    .catch(error => {
      console.error('Error fetching job details:', error);
      throw error;
    }); 
  }
  static async cancelDonationAppointment(payload) {

    return Rest.post(`${API_BASE_URL}/cancel-appointment`, payload)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error canceling donation appointment :', error);
        throw error;
      });
  }
  
  static async donorNotShow(payload) {

    return Rest.post(`${API_BASE_URL}/donor-no-show`, payload)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error adding donor not show :', error);
        throw error;
      });
  }


    
  static async updateDonorPunctuality(payload) {

    return Rest.post(`${API_BASE_URL}/is-donor-punctual`, payload)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error adding donor not show :', error);
        throw error;
      });
  }


   
  static async getCollectedSampleCount(payload) {

    return Rest.post(`${API_BASE_URL}/collected-sample-count`, payload)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error getting sample count :', error);
        throw error;
      });
  }
  // static async getJobsList(pagination) {
  //   // Dummy data for Jobs List
  //   return {
  //     "success": true,
  //     "message": " Jobs List fetched successfully.",

  //     "data": {
  //       "total": 12,
  //       "limit": 10,
  //       "offset": 0,
  //       "list": [
  //         { 
  //           "id" : "1",
  //           "date": "September 6, 2022",
  //           "time": "10:00 am",
  //           "jobNumber": "SH-00000006",
  //           "location": "Downtown Clinic",
  //           "sample_id": "1",
  //           "sample_name": "Blood",
  //           "compensation": "5", 
  //           "appointmentLenth" : "10 Minutes",
  //           "matched_sample": "no",

  //           "smoker_allowed": "no",
  //           "herbal_vitamins": "no",
  //           "medication_allowed" : null,
  //           "herbal_vitamin_note" : null,
  //           "medication_reason" : null,
  //           "donor_restriction_note" : "Test restriction",

  //           "samples": [
  //             { 
  //               "sample_name": "Blood",
  //               "sample_id": 1,
  //               "instruction": "Test Note",
  //               "sample_volume": "135",
  //             }

  //           ]
  //         },
  //         {
  //           "id" : "2",
  //           "date": "August 31, 2022",
  //           "time": "11:30 am",
  //           "jobNumber": "SH-00000007",
  //           "location": "City Hospital",
  //           "sample_id": "2",
  //           "sample_name": "Urine",
  //           "compensation": "15",
  //           "appointmentLenth" : "15 Minutes",
  //           "matched_sample": "no",

  //           "smoker_allowed": "yes",
  //           "herbal_vitamins": "no",
  //           "medication_allowed" : "no",
  //           "herbal_vitamin_note" : "2 hours",
  //           "medication_reason" : "Dibetic medicaion not allowed",
  //           "donor_restriction_note" : "Test restriction",

  //           "samples": [
  //             { 
  //               "sample_name": "Urine",
  //               "sample_id": 2,
  //               "instruction": "Test Note",
  //               "sample_volume": "135",
  //             }

  //           ]
  //         },
  //         {
  //           "id" : "3",
  //           "date": "August 31, 2022",
  //           "time": "02:00 pm",
  //           "jobNumber": "SH-00000008",
  //           "location": "Health Center A",
  //           "sample_id": "3",
  //           "sample_name": "Exhaled Breath",
  //           "compensation": "25",
  //           "appointmentLenth" : "15 Minutes",
  //           "matched_sample": "no",
  //           "smoker_allowed": "no",
  //           "herbal_vitamins": "no",
  //           "medication_allowed" : null,
  //           "herbal_vitamin_note" : null,
  //           "medication_reason" : null,
  //           "donor_restriction_note" : "Test restriction",

  //           "samples": [
  //             { 
  //               "sample_name": "Exhaled Breath",
  //               "sample_id": 3,
  //               "instruction": "Test Note",
  //               "sample_volume": "135",
  //             }
  //           ]
  //         },
  //         {
  //           "id" : "4",
  //           "date": "January 11, 2023",
  //           "time": "09:00 am",
  //           "jobNumber": "SH-00000009",
  //           "location": "Eastside Medical",
  //           "sample_id": "4",
  //           "sample_name": "Saliva",
  //           "compensation": "50",
  //           "appointmentLenth" : "15 Minutes",
  //           "matched_sample": "no",

  //           "smoker_allowed": "no",
  //           "herbal_vitamins": "no",
  //           "medication_allowed" : null,
  //           "herbal_vitamin_note" : null,
  //           "medication_reason" : null,
  //           "donor_restriction_note" : "Test restriction",

  //           "samples": [
  //             { 
  //               "sample_name": "Saliva",
  //               "sample_id": 4,
  //               "instruction": "Test Note",
  //               "sample_volume": "135",
  //             }
  //           ]
  //         },
  //         { 
  //           "id" : "5",
  //           "date": "December 1, 2022",
  //           "time": "01:00 pm",
  //           "jobNumber": "SH-00000010",
  //           "location": "Westside Clinic",
  //           "sample_id": "5, 8",
  //           "sample_name": "Buccal Swab, Stool",
  //           "compensation": "15",
  //           "appointmentLenth" : "15 Minutes",
  //           "matched_sample": "yes",
  //           "smoker_allowed": "no",
  //           "herbal_vitamins": "no",
  //           "medication_allowed" : null,
  //           "herbal_vitamin_note" : null,
  //           "medication_reason" : null,
  //           "donor_restriction_note" : "Test restriction",

  //           "samples": [
  //             { 
  //               "sample_name": "Buccal Swab",
  //               "sample_id": 5,
  //               "sample_name": "Stool",
  //               "instruction": "Test Note",
  //               "sample_volume": "135",
  //             },
  //             { 
  //               "sample_name": "Stool",
  //               "sample_id": 8,
  //               "instruction": "Test Note",
  //               "sample_volume": "135",
  //             }
  //           ]
  //         },
  //         { 
  //           "id" : "6",
  //           "date": "December 1, 2022",
  //           "time": "01:15 pm",
  //           "jobNumber": "SH-00000010",
  //           "location": "Westside Clinic",
  //           "sample_id": "5, 8",
  //           "sample_name": "Buccal Swab, Stool",
  //           "compensation": "15",
  //           "appointmentLenth" : "15 Minutes",
  //           "matched_sample": "yes",
  //           "smoker_allowed": "no",
  //           "herbal_vitamins": "no",
  //           "medication_allowed" : null,
  //           "herbal_vitamin_note" : null,
  //           "medication_reason" : null,
  //           "donor_restriction_note" : "Test restriction",

  //           "samples": [
  //             { 
  //               "sample_name": "Buccal Swab",
  //               "sample_id": 5,
  //               "sample_name": "Stool",
  //               "instruction": "Test Note",
  //               "sample_volume": "135",
  //             },
  //             { 
  //               "sample_name": "Stool",
  //               "sample_id": 8,
  //               "instruction": "Test Note",
  //               "sample_volume": "135",
  //             }
  //           ]
  //         },
  //         { 
  //           "id" : "7",
  //           "date": "September 6, 2022",
  //           "time": "10:05 am",
  //           "jobNumber": "SH-00000011",
  //           "location": "Downtown Clinic",
  //           "sample_id": "5",
  //           "sample_name": "Buccal Swab",
  //           "compensation": "5", 
  //           "appointmentLenth" : "10 Minutes",
  //           "matched_sample": "no",

  //           "smoker_allowed": "no",
  //           "herbal_vitamins": "no",
  //           "medication_allowed" : null,
  //           "herbal_vitamin_note" : null,
  //           "medication_reason" : null,
  //           "donor_restriction_note" : "Test restriction",

  //           "samples": [
  //             { 
  //               "sample_name": "Buccal Swab",
  //               "sample_id": 5,
  //               "instruction": "Test Note",
  //               "sample_volume": "135",
  //             }

  //           ]
  //         },
  //         { 
  //           "id" : "8",
  //           "date": "September 6, 2022",
  //           "time": "10:05 am",
  //           "jobNumber": "SH-00000012",
  //           "location": "Downtown Clinic",
  //           "sample_id": "6",
  //           "sample_name": "Hair Follicle",
  //           "compensation": "5", 
  //           "appointmentLenth" : "10 Minutes",
  //           "matched_sample": "no",

  //           "smoker_allowed": "no",
  //           "herbal_vitamins": "no",
  //           "medication_allowed" : null,
  //           "herbal_vitamin_note" : null,
  //           "medication_reason" : null,
  //           "donor_restriction_note" : "Test restriction",

  //           "samples": [
  //             { 
  //               "sample_name": "Hair Follicle",
  //               "sample_id": 6,
  //               "instruction": "Test Note",
  //               "sample_volume": "135",
  //             }

  //           ]
  //         },
  //         { 
  //           "id" : "9",
  //           "date": "September 6, 2022",
  //           "time": "10:05 am",
  //           "jobNumber": "SH-00000006",
  //           "location": "Downtown Clinic",
  //           "sample_id": "1",
  //           "sample_name": "Blood",
  //           "compensation": "5", 
  //           "appointmentLenth" : "10 Minutes",
  //           "matched_sample": "no",

  //           "smoker_allowed": "no",
  //           "herbal_vitamins": "no",
  //           "medication_allowed" : null,
  //           "herbal_vitamin_note" : null,
  //           "medication_reason" : null,
  //           "donor_restriction_note" : "Test restriction",

  //           "samples": [
  //             { 
  //               "sample_name": "Blood",
  //               "sample_id": 1,
  //               "instruction": "Test Note",
  //               "sample_volume": "135",
  //             }

  //           ]
  //         },
  //         { 
  //           "id" : "10",
  //           "date": "September 6, 2022",
  //           "time": "10:05 am",
  //           "jobNumber": "SH-00000013",
  //           "location": "Downtown Clinic",
  //           "sample_id": "7",
  //           "sample_name": "Skin Tape",
  //           "compensation": "5", 
  //           "appointmentLenth" : "10 Minutes",
  //           "matched_sample": "no",

  //           "smoker_allowed": "no",
  //           "herbal_vitamins": "no",
  //           "medication_allowed" : null,
  //           "herbal_vitamin_note" : null,
  //           "medication_reason" : null,
  //           "donor_restriction_note" : "Test restriction",

  //           "samples": [
  //             { 
  //               "sample_name": "Skin Tape",
  //               "sample_id": 7,
  //               "instruction": "Test Note",
  //               "sample_volume": "135",
  //             }

  //           ]
  //         },
  //         { 
  //           "id" : "11",
  //           "date": "September 6, 2022",
  //           "time": "10:05 am",
  //           "jobNumber": "SH-00000014",
  //           "location": "Downtown Clinic",
  //           "sample_id": "1",
  //           "sample_name": "Blood",
  //           "compensation": "1", 
  //           "appointmentLenth" : "10 Minutes",
  //           "matched_sample": "no",

  //           "smoker_allowed": "no",
  //           "herbal_vitamins": "no",
  //           "medication_allowed" : null,
  //           "herbal_vitamin_note" : null,
  //           "medication_reason" : null,
  //           "donor_restriction_note" : "Test restriction",

  //           "samples": [
  //             { 
  //               "sample_name": "Blood",
  //               "sample_id": 1,
  //               "instruction": "Test Note",
  //               "sample_volume": "135",
  //             }

  //           ]
  //         },
  //         { 
  //           "id" : "12",
  //           "date": "September 6, 2022",
  //           "time": "10:05 am",
  //           "jobNumber": "SH-00000014",
  //           "location": "Downtown Clinic",
  //           "sample_id": "8",
  //           "sample_name": "Stool",
  //           "compensation": "5", 
  //           "appointmentLenth" : "10 Minutes",
  //           "matched_sample": "no",

  //           "smoker_allowed": "no",
  //           "herbal_vitamins": "no",
  //           "medication_allowed" : null,
  //           "herbal_vitamin_note" : null,
  //           "medication_reason" : null,
  //           "donor_restriction_note" : "Test restriction",

  //           "samples": [
  //             { 
  //               "sample_name": "Stool",
  //               "sample_id": 8,
  //               "instruction": "Test Note",
  //               "sample_volume": "135",
  //             }

  //           ]
  //         },
  //         // { 
  //         //   "id" : "13",
  //         //   "date": "December 1, 2022",
  //         //   "time": "01:20 pm",
  //         //   "jobNumber": "SH-00000010",
  //         //   "location": "Westside Clinic",
  //         //   "sample_id": "5, 8",
  //         //   "sample_name": "Buccal Swab, Stool",
  //         //   "compensation": "15",
  //         //   "appointmentLenth" : "15 Minutes",
  //         //   "matched_sample": "yes",
  //         //   "smoker_allowed": "no",
  //         //   "herbal_vitamins": "no",
  //         //   "medication_allowed" : null,
  //         //   "herbal_vitamin_note" : null,
  //         //   "medication_reason" : null,
  //         //   "donor_restriction_note" : "Test restriction",

  //         //   "samples": [
  //         //     { 
  //         //       "sample_name": "Buccal Swab",
  //         //       "sample_id": 5,
  //         //       "sample_name": "Stool",
  //         //       "instruction": "Test Note",
  //         //       "sample_volume": "135",
  //         //     },
  //         //     { 
  //         //       "sample_name": "Stool",
  //         //       "sample_id": 8,
  //         //       "instruction": "Test Note",
  //         //       "sample_volume": "135",
  //         //     }
  //         //   ]
  //         // },
  //       ]
  //     }
  //   };
  // }

  static async anotherAppointmentList(params) {
    return Rest.post('/fetch-available-slots', params)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error in fetching available slots:', error);
        throw error;
    });
  }

  static async exportDonorList(filters) {
    return Rest.post(`${API_BASE_URL}/export-donor`, { filters })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error exporting donor list:', error);
        throw error;
      });
  }


  //update endpoint when api received
  static async exportUpcomingDonationList(params){
      return Rest.post('/export-upcoming-donations', params)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error in fetching upcoming donations:', error);
        throw error;
      });
  }

  //update endpoint when api received
  static async exportDonationHistoryList(filters) {
    return Rest.post(`${API_BASE_URL}/export-donation-history`,  filters )
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error exporting donation history list:', error);
        throw error;
      });
  }

  static async getDonorDetails(user_id) {

    return Rest.post(`${API_BASE_URL}/user/view-donor`, { user_id });
  };

  static async fetchDonorTotalQuantity(params){
    return Rest.post('/fetch-donor-gender-quantity', params)
    .then(response => {
      return response.data;
    })
    .catch(error => {
      console.error('Failed to fetching donor quantity:', error);
      throw error;
    });
  }
  
  static async updateGender(params){
    return Rest.post('/update-gender', params)
    .then(response =>{
      return response.data;
    }).catch(error => {
       throw error.response?.data || error.message;
    });
  }

  
  static async updateTravelDistance(params){
    return Rest.post('/update-travel-distance', params)
    .then(response =>{
      return response.data;
    }).catch(error => {
       throw error.response?.data || error.message;
    });
  }

  static async saveRaceEthnicity(params, isUpdate = false) {
    const url = isUpdate ? '/user/update-race' : '/user/add-race';
    return Rest.post(url, {
      action: isUpdate ? 'update' : 'add',
      ...params
    }).then(response => response.data);
  }
  
  static async updateSmsAlerts(params) {
    return Rest.post('/receive-sms-alerts', params)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response?.data || error.message;
      });
  }

  static async updateDonateSample(params) {
    return Rest.post("/update-donate-choice", params)
      .then((response) => response.data)
      .catch((error) => {
        console.error("Failed to update donation:", error);
        throw error.response?.data || error.message;
      });
  }

  static async fetchHealthQuestionnaire(){
    return Rest.get('/get-health-question')
    .then(response => {
      return response.data;
    })
    .catch(error => {
      console.error('Error fetching health questionnaire:', error);
      throw error;
    }); 
  }
  static async updateHealthData(payload) {  //user profile health questionnaire add.update
    return Rest.post("/user/update-health-data", payload )
        .then((response) => response.data)
        .catch((error) => {
          console.error("Error updating health data:", error);
          throw error;
        });
  }

  //job board while accepting opportunity
  static async updateHealthDataJobBoardOpportunity(payload) {   
    return Rest.post("/user/opportunity-update-health-data", payload )
        .then((response) => response.data)
        .catch((error) => {
          console.error("Error updating health data:", error);
          throw error;
        });
  }


  //get paid serviecs
  static async getPaymentMethod(payload){
    return Rest.post("/user/fetch-payment-method", payload)
        .then((response) => response.data)
        .catch((error) => {
          console.error("Error getting payment method:", error);
          throw error;
        });
  }

  static async confirmDonorPayment(token, amount) {  

    const payload = {
      payment_token : token,
      amount : amount,
    }
    return Rest.post("/payment-method-confirm", payload )
        .then((response) => response.data)
        .catch((error) => {
          console.error("Error while confirming payment method:", error);
          throw error;
        });
  }

  static async savePaymentMethod(payload){
    return Rest.post("user/save-payment-method", payload)
      .then((response) => response.data)
      .catch((error) => {
        console.error("Error saving payment method");
        throw error;
      })
  }
    static async verifyPaymentMethodToken(payload) {  
    return Rest.post("/payment-method-token-verify", payload )
        .then((response) => response.data)
        .catch((error) => {
          console.error("Error while verifying token:", error);
          throw error;
        });
  }

}

export function getStatusLabel(statusId) {
  const status = statusTypes.find((item) => item.id === statusId);

  if (!status) return '-'; 
  return status.label;
}
export const statusTypes = [ 
  { id: 1, label: 'Accept', value: 1 },  
  { id: 2, label: 'Cancel', value: 2 },  
  { id: 3, label: 'Completed', value: 3 },  //Collect
  { id: 4, label: 'No show', value: 4 }, 
];


